import { SelectedDateRange } from 'types/misc';
import { ReportBuilderClientData } from 'screens/WidgetGenerator/reportGeneratorComponents/types';
import { rakeWeighterExecutionLabel } from 'utils/rakeWeighterExecutions';

export const parseSelectedDateRange = (key: string): SelectedDateRange => {
  const datesSplitBySpace = key.split(' ');
  return {
    value: key,
    startDate: datesSplitBySpace[0],
    endDate: datesSplitBySpace[1],
  };
};

export const rakeWeighterExecutionLabelForFilter = (
  rakeWeighterExecutionId: number,
  clientData: ReportBuilderClientData,
): string => {
  const rakeWeighterExecution = Object.values(clientData.rakeWeighterExecutionsBySurveyGroup)
    .flat()
    .find((instance) => instance.id === rakeWeighterExecutionId);
  if (!rakeWeighterExecution) {
    return `MISSING rakeWeighterExecution for id #${rakeWeighterExecutionId}`;
  }

  return rakeWeighterExecutionLabel(rakeWeighterExecution);
};
